import React from 'react'
import { GroupWrapper, GroupedButton } from './styles'

const BtnGrouped = ({ li, sel, fn, field }) => {
  return (
    <GroupWrapper>
      {li.map((btn, i) =>
        <GroupedButton
          key={i}
          idx={i}
          len={li.length}
          btnTxt={btn.label}
          val={btn.value}
          sel={sel}
          onClick={() => fn(btn.value, field)}
        />
      )}
    </GroupWrapper>
  )
}

export default BtnGrouped
